import Vue from 'vue'
import VueRouter from 'vue-router'
import VuexRouterSync from 'vuex-router-sync'

import routes from '@/routes'
import store from '@/store'

import { createRouteGuard } from '@/plugins/routeGuard'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }

  return originalPush.call(this, location).catch(err => {
    return err
  })
}

export const router = new VueRouter({ routes })
router.beforeEach(createRouteGuard(store))

VuexRouterSync.sync(store, router)
Vue.router = router
